import { styled } from 'baseui'

export const TableWrap = styled('div', {
  position: 'relative',
  overflowX: 'auto',
  marginTop: '0.5rem',
})

export const Table = styled('table', {
  width: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'separate',
  borderSpacing: 0,
})


export const TheadRow = styled('tr', {
  textAlign: 'left',
})

export const Th = styled('th', ({ $theme }) => ({
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.borderLight,
  fontSize: '0.9125rem',
  color: $theme.colors.textMuted,
  fontWeight: 600,
  whiteSpace: 'nowrap',
}))

export const Td = styled('td', ({ $theme }) => ({
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.65rem',
  paddingRight: '0.65rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.bgAccordion,
  fontSize: '0.875rem',
  verticalAlign: 'middle',
}))

export const IdTh = styled(Th, { width: '6%' })
export const UsernameTh = styled(Th, { width: '18%' })
export const StatusTh = styled(Th, { width: '12%' })
export const OriginTh = styled(Th, { width: '12%' })
export const CreatedAtTh = styled(Th, { width: '18%' })

export const ActionsTh = styled(Th, {
  textAlign: 'right',
  width: '34%',
})

export const ActionsCell = styled(Td, {
  whiteSpace: 'nowrap',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0.35rem',
  flexWrap: 'wrap',
})

export const StatusText = styled<'span', { $active: boolean }>('span', ({ $theme, $active }) => ({
  fontWeight: 600,
  color: $active ? $theme.colors.positive600 : $theme.colors.negative600,
}))
